module.exports = require("./ckb-IR.js");